import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { Stars } from './Stars';
import { SHORT_TESTIMONIALS } from '../data/content';
export function ShortTestimonials() {
  return <section className="px-5 py-10" data-id="element-145">
      <div className="mx-auto max-w-md" data-id="element-146">
        <h2 className="text-center font-anton text-2xl leading-tight text-white" data-id="element-147">
          Coaches como tú ya lo están aplicando
        </h2>

        <div className="mt-6 grid grid-cols-1 gap-3" data-id="element-148">
          {SHORT_TESTIMONIALS.map((t, i) => <motion.figure key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="rounded-xl border border-white/10 bg-[#111]/90 p-4" data-id="element-149">
              <div className="flex items-center justify-between" data-id="element-150">
                <Stars data-id="element-151" />
                <QuoteIcon className="h-5 w-5 text-[#F5C518]/50" data-id="element-152" />
              </div>
              <blockquote className="mt-2.5 text-[14px] leading-snug text-neutral-200" data-id="element-153">
                "{t.text}"
              </blockquote>
              <figcaption className="mt-2.5 text-[13px] font-600 text-white" data-id="element-154">
                {t.name}, {t.age}{' '}
                <span className="font-400 text-neutral-400" data-id="element-155">· {t.city}</span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}